import { Button, Paper, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import { MOBILE_CONTAINER_WIDTH } from '@mopla/constants';
import { Footer, NativePageBackground } from '@mopla/ui';

export const WelcomeEntryRoot = styled(Paper)(({ theme }) => ({
	height: '100%',
	maxWidth: MOBILE_CONTAINER_WIDTH,
	margin: 'auto',
}));

export const WelcomeEntryFooter = styled(Footer)(() => ({
	display: 'flex',
	flexDirection: 'column',
	gap: 16,
}));

export const BackButton = styled(Button)(({ theme }) => ({
	fontFamily: '"Poppins", sans-serif',
	fontStyle: 'normal',
	fontWeight: 500,
	fontSize: '15px',
	lineHeight: '150%',
	color: theme.palette.primary.main,
	padding: 8,
	paddingLeft: 0,
	'&:hover': {
		backgroundColor: 'transparent',
	},

	'& .MuiButton-startIcon': {
		marginRight: 4,
	},

	'& .MuiSvgIcon-root': {
		fontSize: '24px',
	},
}));

export const Title = styled(Typography, {
	shouldForwardProp: (prop) => prop !== 'marginBottom',
})<{ marginBottom?: string }>(({ theme, marginBottom }) => ({
	...theme.typography.body1,
	color: theme.palette.neutral[100],
	marginBottom: marginBottom || 0,
}));

export const CheckmarkWrapper = styled('div')(() => ({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	textAlign: 'center',

	svg: {
		marginBottom: '24px',
	},
}));

export const WelcomeBackground = styled(NativePageBackground)(({ theme }) => ({
	backgroundColor: theme.palette.secondary.main,
}));
